
<section class="container-fluid sts-section">

  <app-sts-section-header key="sts-signup-collect-email" [errors]="errors" *ngIf="displayEmail">
    Collect E-mail Address
    <app-sts-section-header-side>
      <div class="text-right"><a
        routerLink="/account/help" app-sts-cms-txt key="sts-need-help">Need help?</a>
      </div>
    </app-sts-section-header-side>
  </app-sts-section-header>

  <app-sts-section-body key="sts-signup-collect-email-body-section" *ngIf="displayEmail">
    <p _ngcontent-c13="">We would need to have your email address on file so it can be used for two factor authentication. Please Enter your email address in the field below.</p>
  </app-sts-section-body>

  <app-sts-section-header key="sts-signup-collect-phone" [errors]="errors" *ngIf="displayPhone">
    Collect Mobile Number
    <app-sts-section-header-side>
      <div class="text-right"><a
        routerLink="/account/help" app-sts-cms-txt key="sts-need-help">Need help?</a>
      </div>
    </app-sts-section-header-side>
  </app-sts-section-header>

  <app-sts-section-body key="sts-signup-collect-phone-body-section" *ngIf="displayPhone">
    <p _ngcontent-c13="">Please provide/validate your mobile number.</p>
  </app-sts-section-body>


  <form #form="ngForm" (ngSubmit)="onSubmit()"
        [formGroup]="signUpForm"
        class="sts-form" autocomplete="off">

    <div class="row sts-form-row">
      <div class="col-24">

        <!-- -->
        <div class="sts-object" *ngIf="displayEmail">

          <div class="sts-label-row">

            <label app-sts-cms-txt key="sts-pick-login-email" for="sts-pick-login-email">
              Email address:
            </label>
          </div>
          <div class="sts-input-row">
            <input type="text"
                   name="sts_pick_email"
                   formControlName="emailInput"
                   maxlength="100"
                   [ngClass]="{'has-errors' : !signUpForm.controls['emailInput'].valid }"
                   class="sts-textbox" >
            <div class="text-danger" *ngIf="signUpForm.controls['emailInput'].invalid">
              <div app-sts-cms-txt key="sts-email-is-required-for-collection" *ngIf="signUpForm.controls['emailInput'].errors['emailRequired']">An email is required</div>
              <div app-sts-cms-txt key="sts-email-is-valid-required" *ngIf="signUpForm.controls['emailInput'].errors['validateEmail']">A valid email is required</div>
            </div>
          </div>


        </div>
        <!-- -->

        <div class="sts-object" *ngIf="displayPhone">

          <div class="sts-label-row">

            <label app-sts-cms-txt key="sts-pick-login-phone" for="sts-pick-login-phone">
              Enter your mobile phone number:
            </label>
          </div>
          <div class="sts-input-row">
            <input type="text"
                   name="sts_pick_phone"
                   formControlName="phoneInput"
                   maxlength="15"
                   [ngClass]="{'has-errors' : !signUpForm.controls['phoneInput'].valid }"
                   class="sts-textbox" >
            <div class="text-danger" *ngIf="signUpForm.controls['phoneInput'].invalid">
              <div app-sts-cms-txt key="sts-phone-is-required-for-collection" *ngIf="signUpForm.controls['phoneInput'].errors['phoneRequired']"> A mobile phone number is required</div>              
              <div app-sts-cms-txt key="sts-phone-is-valid-required" *ngIf="signUpForm.controls['phoneInput'].errors['validatePhone']">A valid phone is required</div>
            </div>
          </div>


        </div>
        <!-- -->



      </div>
    </div>

    <div class="row">
      <div class="col-24">

        <!-- -->
        <div class="sts-object">
          <button app-sts-cms-txt key="sts-cancel-button"
                  class="sts-btn other-sts-btn"
                  type="button"
                  (click)="gotoHome()">
            Cancel
          </button>
          <app-sts-button [submit]="submitter"
                          [disabled]="isSubmitting"
                          key="sts-next-button">
            Next
          </app-sts-button>
        </div>
        <!-- -->

      </div>
    </div>

  </form>


</section>


